import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import Axios, { AxiosError } from 'axios'
import { navigate } from 'gatsby'
import { getDebugLogger } from '../../utils/logger'
import { getAccessToken, logout } from './auth'

const DEBUG_PREFIX = 'ApiRequest'

// 'https://api.advisorplatinum.com' // Prod
// 'https://dev.api.advisorplatinum.com' // Dev
// 'http://localhost:3000' // Local
// const BASE_API_URL = 'https://api.advisorplatinum.com' // FIXME (do-not-push): Change this to dev / prod API url before pushing
const BASE_API_URL = process.env.GATSBY_API_URL || 'http://localhost:3000'

const apiRequest = Axios.create()
const debug = getDebugLogger(DEBUG_PREFIX)

apiRequest.interceptors.request.use(async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  debug('request interceptor', { method: config.method, path: config.url })
  const accessToken = await getAccessToken()
  if (config.headers == undefined) {
    config.headers = {}
  }
  config.headers.authorization = `Bearer ${accessToken}`
  return config
})

apiRequest.interceptors.response.use((response: AxiosResponse): AxiosResponse => {
  debug('response interceptor', { method: response.config.method, path: response.config.url })
  return response
}, (error: AxiosError): Promise<AxiosError> => {
  debug('response interceptor', { error })
  if (error.response?.status == 403) {
    logout()
    navigate('/login')
    return Promise.reject(error)
  }
  return Promise.reject(error)
})

export {
  BASE_API_URL,
  apiRequest
}

